import { ClothingStoreProps } from "./ClothingStore";

interface Props {
  className?: string;
  titleClassName?: string;
  titleWords: ClothingStoreProps["titleWords"];
  description: ClothingStoreProps["description"];
}
const ClothingHeader = ({
  className = "",
  titleWords,
  description,
  titleClassName = "",
}: Props) => {
  return (
    <div className={` ${className}`}>
      <h1
        className={`uppercase text-[2.35rem] flex items-center flex-wrap text-wrap gap-2 ${titleClassName}`}
      >
        {titleWords?.map((word, i) => (
          <span
            key={i}
            className={`${
              word.isHighlighted
                ? "there-brat-font text-[#1A8BF7] [text-shadow:_0_6px_3px_rgba(26,139,247,0.25)]"
                : "sporty-pro-font bg-clip-text text-transparent bg-gradient-to-r from-white to-white/50"
            }`}
          >
            {word.text}
          </span>
        ))}
      </h1>
      <p className="inter-font text-white text-[0.8rem] max-w-[95%]">
        {description}
      </p>
    </div>
  );
};

export default ClothingHeader;
